// @ts-ignore
import workerText from 'raw-loader!../wasm-pkg/worker.js';

export function createWorker() {
    const workerBlob = new Blob([workerText], {
        type: 'application/javascript',
    });

    const blobUrl = window.URL.createObjectURL(workerBlob);
    return new Worker(blobUrl);
}
